import React from "react";
import { Close, FilterList } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";

import { Button } from "../Button";
import { FilterDrawer, useStyles } from "./styles";

interface IProps {
  open: boolean;
  loading: boolean;
  countFilter: number;
  handleFilter(): void;
  setCleanFilter(): void;
  filterDisabled: boolean;
  setOpen(value: boolean): void;
}

export const DrawerFilter: React.FC<IProps> = ({
  open,
  loading,
  setOpen,
  children,
  countFilter,
  handleFilter,
  filterDisabled,
  setCleanFilter,
}) => {
  const { filterHeader, filterFooter, btnClose, body } = useStyles();

  return (
    <>
      <Button
        disabled={loading}
        label={String(countFilter)}
        variant="outlined"
        onClick={() => setOpen(!open)}
        startIcon={<FilterList />}
      />

      <FilterDrawer anchor="right" open={open}>
        <Box className={filterHeader}>
          <Typography variant="h5" color="primary" mt={2} mb={2}>
            <strong>Filtros</strong>
          </Typography>
          <Box className={btnClose}>
            <IconButton onClick={() => setOpen(!open)}>
              <Close />
            </IconButton>
          </Box>
        </Box>

        <Box className={body}>{children}</Box>

        <Box className={filterFooter}>
          <Button
            disabled={loading}
            label="Limpar"
            variant="outlined"
            onClick={setCleanFilter}
          />
          <Button
            disabled={loading || filterDisabled}
            label="Filtrar"
            onClick={handleFilter}
          />
        </Box>
      </FilterDrawer>
    </>
  );
};
